// @ts-nocheck
import React from 'react';
import classNames from 'classnames';

import css from './GigStatusBadge.module.css';

export const GIG_STATUS_LABELS: Record<string, string> = {
  PENDING_FUNDING: 'Pending funding',
  FUNDED: 'Live on noticeboard',
  CLAIMED: 'Claimed by runner',
  READY_FOR_SETTLEMENT: 'Ready for settlement',
  SETTLED_ONCHAIN: 'Settled on-chain',
  SETTLED: 'Settled on-chain',
  SETTLED_MERCHANT_FAVOR: 'Settled — merchant favor',
  SETTLED_RUNNER_FAVOR: 'Settled — runner favor',
  CANCELLED: 'Cancelled & refunded',
  DISPUTED: 'Disputed — settlement paused',
};

const STATUS_VARIANT: Record<string, string> = {
  PENDING_FUNDING: css.pendingFunding,
  FUNDED: css.funded,
  CLAIMED: css.claimed,
  READY_FOR_SETTLEMENT: css.readyForSettlement,
  SETTLED_ONCHAIN: css.settled,
  SETTLED: css.settled,
  SETTLED_MERCHANT_FAVOR: css.settled,
  SETTLED_RUNNER_FAVOR: css.settled,
  CANCELLED: css.cancelled,
  DISPUTED: css.disputed,
};

export interface GigStatusBadgeProps {
  status: string;
  label?: string;
  large?: boolean;
  className?: string;
}

const GigStatusBadge: React.FC<GigStatusBadgeProps> = ({
  status,
  label,
  large = false,
  className = null,
}) => {
  const normalized = String(status || '').toUpperCase();
  const displayLabel = label || GIG_STATUS_LABELS[normalized] || status;

  return (
    <span
      className={classNames(
        css.badge,
        STATUS_VARIANT[normalized] || css.default,
        large ? css.large : null,
        className
      )}
      data-gig-status={normalized}
    >
      {displayLabel}
    </span>
  );
};

export default GigStatusBadge;
